<template>
  <div class="consultations-page" :class="{ 'consultations-page--en': !isAr }">
    <section class="consultations">
      <b-container fluid class="px-0">
        <!-- نصف للرسم ونصف للنص — بدون تراكب -->
        <b-row
          class="intro-section consult-hero-row align-items-stretch flex-column flex-md-row mx-0"
          :class="{ 'flex-md-row-reverse': isAr }"
        >
          <b-col
            cols="12"
            md="6"
            lg="5"
            class="consult-hero-copy d-flex align-items-center order-2 order-md-1"
          >
            <div class="text-section">
              <div class="consult-hero-text-panel">
                <h1 class="mb-3 consult-hero-title"><b>{{ langDec.consult_page_hero_title }}</b></h1>
                <p class="consult-hero-lead">{{ langDec.consult_page_hero_lead }}</p>
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="7"
            class="consult-hero-art order-1 order-md-2 pa-0"
            aria-hidden="true"
          ></b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row>
          <b-col xl="12" lg="12" md="12" class="text-center">
            <div class="text-section">
              <div>
                <div class="title">
                  <h2 class="name">
                    {{ langDec.consult_page_blurb_title }}
                  </h2>
                </div>
                <p class="consult-blurb-body">
                  {{ langDec.consult_page_blurb_body }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="section93">
      <b-container fluid>
        <b-row>
          <b-col xl="12" lg="12" md="12" sm="12" class="px-4">
            <div class="text-section">
              <div>
                <div class="title">
                  <h2 class="name">
                    {{ langDec.consult_page_latest_heading }}
                  </h2>
                </div>
                <div class="text-center text-danger my-2 loadingBox" v-show="pageIsLoading">
                  <b-spinner class="align-middle" />
                </div>
                <template v-if="!pageIsLoading">
                  <div v-if="consultations.length === 0" class="text-center text-muted my-4">
                    {{ langDec.consult_page_empty }}
                  </div>
                  <b-row v-else class="consult-cards-row">
                    <b-col
                      v-for="item in consultations"
                      :key="consultationKey(item)"
                      cols="12"
                      md="6"
                      class="consult-cards-col mb-4"
                    >
                      <div
                        class="consultation-card itemBox h-100"
                        role="button"
                        tabindex="0"
                        @click="goToConsultation(item)"
                        @keyup.enter="goToConsultation(item)"
                      >
                        <div class="consult-card-accent" aria-hidden="true" />
                        <div class="consult-card-inner">
                          <div v-if="consultationTags(item).length" class="consult-card-tags">
                            <b-badge
                              v-for="(tag, idx) in consultationTags(item)"
                              :key="idx"
                              variant="primary"
                              class="consult-card-badge"
                            >{{ tag }}</b-badge>
                          </div>
                          <h3 v-if="consultationSubject(item)" class="consult-card-subject">
                            {{ consultationSubject(item) }}
                          </h3>
                          <p v-if="consultationQuestion(item)" class="consult-card-question">
                            {{ consultationQuestion(item) }}
                          </p>
                          <div class="consult-card-meta">
                            <div v-if="consultationDoctor(item)" class="consult-meta-chip">
                              <span class="consult-meta-label">{{ langDec.consult_meta_consultant }}</span>
                              <span
                                class="consult-meta-value"
                                :class="{ 'consult-meta-value--doctor-link': Boolean(consultationDoctorProfileId(item)) }"
                                :role="consultationDoctorProfileId(item) ? 'button' : null"
                                :tabindex="consultationDoctorProfileId(item) ? 0 : null"
                                @click.stop="onConsultationDoctorClick(item)"
                                @keyup.enter.stop="onConsultationDoctorClick(item)"
                              >{{ consultationDoctor(item) }}</span>
                            </div>
                            <div v-if="consultationCreatedAt(item)" class="consult-meta-chip">
                              <span class="consult-meta-label">{{ langDec.consult_meta_published }}</span>
                              <span class="consult-meta-value">{{ consultationCreatedAt(item) }}</span>
                            </div>
                            <div v-if="consultationViews(item) != null && consultationViews(item) !== ''" class="consult-meta-chip">
                              <span class="consult-meta-label">{{ langDec.consult_meta_views }}</span>
                              <span class="consult-meta-value">{{ consultationViews(item) }}</span>
                            </div>
                            <div v-if="consultationCountry(item)" class="consult-meta-chip">
                              <span class="consult-meta-label">{{ langDec.consult_meta_country }}</span>
                              <span class="consult-meta-value">{{ consultationCountry(item) }}</span>
                            </div>
                            <div v-if="consultationAge(item) != null && consultationAge(item) !== ''" class="consult-meta-chip">
                              <span class="consult-meta-label">{{ langDec.consult_meta_age }}</span>
                              <span class="consult-meta-value">{{ consultationAge(item) }}</span>
                            </div>
                          </div>
                          <div class="consult-card-footer">
                            <span class="consult-card-cta">{{ langDec.consult_card_view_details }}</span>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </template>
                <div v-if="!pageIsLoading && totalCount > 0" class="my-3">
                  <b-pagination
                    v-model="pageNumber"
                    :per-page="pageSize"
                    :total-rows="totalCount"
                    align="center"
                    size="sm"
                    @change="onPageChanged"
                  />
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="subscribe">
      <div class="subscribe-inner col-md-12 py-5 my-5 text-center">
        <h2 class="consult-subscribe-heading px-3">{{ langDec.consult_subscribe_heading }}</h2>
        <div class="description">
          <p
            v-if="!googleplay && !applestore"
            class="consult-app-unavailable mt-3 px-3"
          >
            <b>{{ langDec.experts_page_app_unavailable }}</b>
          </p>
          <b-button
            v-if="!googleplay && !applestore"
            class="px-4 py-2 my-4"
            variant="primary"
            @click="goToRoute('contactus')"
          >
            {{ langDec.nav_contact }}
          </b-button>
        </div>
        <div v-if="googleplay || applestore" class="action-btns mt-4">
          <b-button
            v-if="applestore"
            class="consult-store-btn consult-store-btn--apple px-4 py-3 mx-3 my-3"
            @click="goTowebsite(applestore)"
          >
            <div
              class="store-badge-inner carousel-btn-in-div px-3"
              :class="{ 'store-badge-inner--en': !isAr }"
            >
              <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                <img
                  class="store-badge-inner__apple-img"
                  src="../assets/images/Apple_logo_white.svg.png"
                  alt=""
                >
              </div>
              <div class="carousel-btn-in-div-text store-badge-inner__text consult-store-text">
                <span>{{ langDec.nav_available_on }}</span>
                <br>
                <span>App Store</span>
              </div>
            </div>
          </b-button>
          <b-button
            v-if="googleplay"
            class="consult-store-btn consult-store-btn--google px-4 py-3 mx-3 my-3"
            variant="primary"
            @click="goTowebsite(googleplay)"
          >
            <div
              class="store-badge-inner px-3"
              :class="{ 'store-badge-inner--en': !isAr }"
            >
              <div class="store-badge-inner__icon store-badge-inner__icon--google">
                <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" d="M0,0h40v40H0V0z" />
                  <g>
                    <path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335" />
                    <path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04" />
                    <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4" />
                    <path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853" />
                  </g>
                </svg>
              </div>
              <div class="carousel-btn-in-div-text store-badge-inner__text consult-store-text">
                <span>{{ langDec.nav_available_on }}</span>
                <br>
                <span>Google Play</span>
              </div>
            </div>
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { resolveDoctorProfileIdFromConsultationPayload } from "../utils/doctorProfileNav.js";

export default {
  name: "Consultations",
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      consultations: [],
      pageIsLoading: false,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  computed: {
    ...mapGetters(["getLangData", "getlang", "authToken"]),
    langDec() {
      return this.getLangData || {};
    },
    currentLang() {
      return this.getlang || "ar";
    },
    isAr() {
      return this.currentLang === "ar";
    },
  },
  created() {
    this.fetchConsultations();
  },
  methods: {
    consultationUrl() {
      const base = process.env.VUE_APP_API_URL || "";
      return `${base}Consultation`;
    },
    consultationKey(item) {
      return item.id ?? item.consultationId ?? item.slug ?? JSON.stringify(item);
    },
    consultationTags(item) {
      const raw =
        item.categories ||
        item.tags ||
        item.specializations ||
        item.interests ||
        item.categoryNames ||
        item.specializationNames ||
        [];
      const list = Array.isArray(raw) ? raw : [];
      return list
        .slice(0, 10)
        .map((t) => (typeof t === "string" ? t : t.name || t.title || t.interestName || ""))
        .filter(Boolean);
    },
    stripConsultationHtml(value) {
      if (value == null || typeof value !== "string") return "";
      const txt = value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
      return txt;
    },
    formatConsultationDate(raw) {
      if (raw == null || raw === "") return "";
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return String(raw);
      const loc = this.isAr ? "ar-EG" : "en-US";
      return d.toLocaleDateString(loc, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    consultationSubject(item) {
      const s =
        item.subject ||
        item.questionTitle ||
        item.title ||
        item.consultationTitle ||
        "";
      return this.stripConsultationHtml(String(s)).trim();
    },
    consultationQuestion(item) {
      let q = this.stripConsultationHtml(String(item.question || "")).trim();
      const sub = this.consultationSubject(item);
      if (q && sub && q === sub) q = "";
      if (!q) {
        const body =
          item.shortDescription ||
          item.description ||
          item.summary ||
          item.answerPreview ||
          "";
        q = this.stripConsultationHtml(String(body)).trim();
        if (sub && q.startsWith(sub)) {
          q = q.slice(sub.length).trim().replace(/^[،,.]/, "").trim();
        }
      }
      if (!q && sub) return "";
      if (!q && !sub) return "—";
      return q;
    },
    consultationDoctor(item) {
      const d = item.doctor || item.expert || item.consultant;
      return (
        item.doctorName ||
        item.consultantName ||
        item.expertName ||
        item.answeredByName ||
        item.doctorFullName ||
        (typeof d === "object" && d ? d.fullName || d.name || d.doctorName : "") ||
        ""
      ).trim();
    },
    consultationDoctorProfileId(item) {
      return resolveDoctorProfileIdFromConsultationPayload(item);
    },
    onConsultationDoctorClick(item) {
      const id = resolveDoctorProfileIdFromConsultationPayload(item);
      if (!id) return;
      this.$router.push({
        name: "expertProfile",
        params: { id: String(id) },
      }).catch(() => {});
    },
    consultationCreatedAt(item) {
      const raw =
        item.createdAt ||
        item.publishDate ||
        item.publishDateTime ||
        item.publishedAt ||
        item.answerDate ||
        item.updatedAt;
      return raw ? this.formatConsultationDate(raw) : "";
    },
    consultationViews(item) {
      const v = item.views ?? item.viewCount ?? item.numberOfViews ?? item.viewsCount;
      if (v === undefined || v === null || v === "") return null;
      return v;
    },
    consultationCountry(item) {
      const c = item.country;
      if (typeof c === "string") return c.trim();
      if (c && typeof c === "object") return (c.name || c.countryName || "").trim();
      return String(item.countryName || "").trim();
    },
    consultationAge(item) {
      const a = item.age ?? item.patientAge ?? item.ageYears;
      if (a === undefined || a === null || a === "") return null;
      return a;
    },
    goToConsultation(item) {
      const id = item.id ?? item.consultationId ?? item.slug;
      if (id == null) return;
      this.$router.push({
        name: "consultation",
        params: { id: String(id) },
      }).catch(() => {});
    },
    parsePagedResponse(responseData) {
      const root = responseData && responseData.data !== undefined ? responseData.data : responseData;
      let items = [];
      let total = 0;

      if (Array.isArray(root)) {
        items = root;
      } else if (root && Array.isArray(root.items)) {
        items = root.items;
        total =
          root.totalCount ??
          root.total ??
          root.totalRecords ??
          root.count ??
          0;
      } else if (root && Array.isArray(root.data)) {
        items = root.data;
        total = root.totalCount ?? root.total ?? 0;
      }

      if (!total && responseData && typeof responseData.totalCount === "number") {
        total = responseData.totalCount;
      }
      if (!total && items.length < this.pageSize) {
        total = (this.pageNumber - 1) * this.pageSize + items.length;
      }
      if (!total && items.length === this.pageSize) {
        total = this.pageNumber * this.pageSize + 1;
      }

      return { items, total };
    },
    fetchConsultations() {
      this.pageIsLoading = true;
      const token = this.authToken;
      const config = {
        params: {
          PageNumber: this.pageNumber,
          PageSize: this.pageSize,
          Status: 4,
        },
      };
      if (token) {
        config.headers = { authorization: `Bearer ${token}` };
      }
      axios
        .get(this.consultationUrl(), config)
        .then((response) => {
          const { items, total } = this.parsePagedResponse(response.data);
          this.consultations = items;
          this.totalCount = total;
        })
        .catch(() => {
          this.consultations = [];
          this.totalCount = 0;
        })
        .finally(() => {
          this.pageIsLoading = false;
        });
    },
    onPageChanged(page) {
      this.pageNumber = page;
      this.fetchConsultations();
    },
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToRoute(name, id) {
      const payload = { name };
      if (id != null) payload.params = { id: String(id) };
      this.$router.push(payload).catch(() => {});
    },
  },
};
</script>

<style scoped>
.consult-hero-row.intro-section {
  margin: 0;
  background: #053d24;
  min-height: 450px;
  height: auto !important;
}

/* عمود الرسم: الخلفية فقط هنا فيظهر الـ vector بوضوح
   أصل الصورة: الرسم على اليسار والمساحة الخالية على اليمين؛ لازم نربط يسار الصورة
   بيسار العمود عشان ما نعرضش نصف الصورة الفاضي في وسط/يمين الهيرو */
.consult-hero-art {
  min-height: 220px;
  background-color: #064e28;
  background-image: url(../assets/images/consultationsGreenBG.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left center;
}

/* عمود النص: خلفية موحّدة والكلام لا يمرّ على الرسم */
.consult-hero-copy {
  background: linear-gradient(165deg, #035c2e 0%, #064e28 48%, #052818 100%);
  padding: 2rem 1.75rem;
}

.consult-hero-text-panel {
  max-width: min(36rem, 100%);
  padding: 0;
}

.consultations .text-section {
  align-items: center;
  margin-inline-end: 0;
  display: flex;
  width: 100%;
}

.consult-hero-title,
.consult-hero-lead {
  text-align: start;
}

.consultations .text-section .consult-hero-title {
  font-size: 40px !important;
  font-weight: bolder !important;
  color: #fff;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

.consult-hero-lead {
  font-size: 1.1rem;
  margin-bottom: 0;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.96);
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
}

.consult-blurb-body {
  text-align: center;
}

.greyBox {
  padding: 50px 40px;
}

.greyBox .text-section {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 20px 30px;
  font-size: 20px;
  width: 100%;
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greyBox .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.greyBox .text-section .pref {
  font-size: 16px;
  color: #858585;
}

.subscribe {
  background-color: #f5f5f5;
}

.subscribe-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.consult-subscribe-heading {
  max-width: 44rem;
  margin-inline: auto;
}

.consult-app-unavailable {
  color: #c0392b;
}

.consult-store-btn {
  color: #fff !important;
}

.consult-store-btn--apple {
  background-color: #000 !important;
  border-color: #000 !important;
}

.consult-store-btn--google {
  border-color: #000 !important;
}

.consult-store-text {
  font-size: 14px;
}

.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.store-badge-inner__text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}

.section93 {
  padding: 40px 40px;
}

.consult-cards-row {
  margin-top: 0.5rem;
}

.consult-cards-col {
  display: flex;
}

.consult-cards-col > .consultation-card.itemBox {
  width: 100%;
}

.consultation-card.itemBox {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  overflow: hidden;
  border: none;
  border-radius: 14px;
  background: #fff;
  box-shadow:
    0 10px 36px rgba(0, 102, 51, 0.09),
    0 2px 8px rgba(0, 102, 51, 0.06);
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  outline: none;
}

.consultation-card.itemBox:hover,
.consultation-card.itemBox:focus {
  transform: translateY(-5px);
  box-shadow:
    0 18px 44px rgba(0, 102, 51, 0.14),
    0 4px 12px rgba(0, 102, 51, 0.08);
}

.consultation-card.itemBox:focus-visible {
  box-shadow:
    0 0 0 3px rgba(0, 102, 51, 0.35),
    0 18px 44px rgba(0, 102, 51, 0.12);
}

.consult-card-accent {
  flex-shrink: 0;
  width: 5px;
  background: linear-gradient(180deg, #006633 0%, #0d8049 100%);
}

.consult-card-inner {
  flex: 1;
  padding: 1.25rem 1.35rem 1rem;
  text-align: start;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.consult-card-tags {
  margin-bottom: 0.65rem;
}

.consult-card-badge {
  font-weight: 600;
  padding: 0.35em 0.65em;
  border-radius: 50rem;
  background-color: #006633 !important;
  border-color: #006633 !important;
  margin-inline-end: 0.35rem;
}

.consult-card-subject {
  font-size: 1.12rem;
  font-weight: 700;
  color: #006633;
  line-height: 1.45;
  margin: 0 0 0.45rem;
}

.consult-card-question {
  font-size: 0.94rem;
  font-weight: 500;
  color: #3d4548;
  line-height: 1.65;
  margin: 0 0 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.consult-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.85rem;
}

.consult-meta-chip {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  background: rgba(0, 102, 51, 0.06);
  border: 1px solid rgba(0, 102, 51, 0.14);
  border-radius: 10px;
  padding: 0.35rem 0.65rem;
  max-width: 100%;
}

.consult-meta-label {
  font-size: 0.7rem;
  color: rgba(0, 102, 51, 0.65);
  text-transform: none;
  letter-spacing: 0;
  margin-bottom: 0.1rem;
}

.consult-meta-value {
  font-size: 0.82rem;
  font-weight: 600;
  color: #2d3436;
  word-break: break-word;
}

.consult-meta-value--doctor-link {
  color: #006633 !important;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.consult-meta-value--doctor-link:hover,
.consult-meta-value--doctor-link:focus {
  color: #004728 !important;
  outline: none;
}

.consult-card-footer {
  display: flex;
  justify-content: flex-start;
  padding-top: 0.25rem;
  margin-top: auto;
  border-top: 1px solid rgba(0, 102, 51, 0.18);
}

.consult-card-cta {
  font-size: 0.85rem;
  font-weight: 700;
  color: #006633;
}

.consultation-card.itemBox:hover .consult-card-cta {
  color: #004728;
}

@media (max-width: 991.98px) {
  .greyBox,
  .section93 {
    padding: 50px 30px;
  }

  .consult-hero-art {
    min-height: 280px;
  }

  .consult-hero-copy {
    padding: 1.75rem 1.35rem;
  }

  .consultations .text-section .consult-hero-title {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .greyBox .text-section {
    padding: 10px;
  }
}

@media (max-width: 767.98px) {
  .greyBox,
  .section93 {
    padding: 40px 10px;
  }

  .consult-hero-art {
    min-height: 240px;
  }

  .consult-hero-copy {
    padding: 1.5rem 1.25rem;
  }
}

html[data-theme="dark"] .greyBox .text-section {
  background-color: #161b22;
  border: 1px solid #30363d;
}

html[data-theme="dark"] .consultation-card.itemBox {
  background: #161b22;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

html[data-theme="dark"] .consult-card-subject {
  color: #8fe9c0;
}

html[data-theme="dark"] .consult-card-question {
  color: #cfd6df;
}

html[data-theme="dark"] .consult-meta-value {
  color: #e8eaed;
}
</style>
